// LEGACY CODE

/*
 * Dependent Dropdowns
 */
function updateDependentDropdown(event) {
  var masterSelect = $(event.target);
  var dependentSelect = $('#' + masterSelect.attr('data-dependent'));
  var dependentChosen = $('#' + dependentSelect.attr('id') + '_chosen');
  dependentSelect.attr('disabled', true).trigger('chosen:updated');
  dependentChosen.addClass('chosen-loading');
  $.get(event.data.url + masterSelect.val(), function (data) {
    dependentSelect.html(data).prop('disabled', false).trigger('chosen:updated');
    dependentChosen.removeClass('chosen-loading');
  });
}

function attachDependentDropdowns() {
  $('select.acquirer').on('change', {
    url: '/merchant_acquirer/'
  }, updateDependentDropdown);
}

var DependentDropdowns = {
  updateDependentDropdown: updateDependentDropdown,
  attachDependentDropdowns: attachDependentDropdowns
};
export default DependentDropdowns;